var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1836 11.7603C8.33936 11.7603 6.04443 9.28223 6.04443 6.21826C6.04443 3.20312 8.36377 0.749512 11.1836 0.749512C14.0278 0.749512 16.3228 3.19092 16.3228 6.19385C16.3228 9.28223 14.04 11.7603 11.1836 11.7603ZM11.1836 9.42871C12.6729 9.42871 13.918 8.06152 13.918 6.19385C13.918 4.39941 12.6729 3.09326 11.1836 3.09326C9.70654 3.09326 8.46143 4.41162 8.46143 6.20605C8.46143 8.07373 9.70654 9.42871 11.1836 9.42871ZM4.05469 22.5635C1.96729 22.5635 0.941895 21.8799 0.941895 20.4028C0.941895 17.0703 5.08008 13.0054 11.1836 13.0054C17.2871 13.0054 21.4253 17.0703 21.4253 20.4028C21.4253 21.8799 20.3999 22.5635 18.3125 22.5635H4.05469ZM3.9082 20.2319H18.459C18.6909 20.2319 18.7764 20.1343 18.7764 19.9634C18.7764 18.3643 16.0176 15.3369 11.1836 15.3369C6.34961 15.3369 3.59082 18.3643 3.59082 19.9634C3.59082 20.1343 3.67627 20.2319 3.9082 20.2319Z",
    fill: "#1A1717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.aa8fc78703d144bd967f8d3549d280c1.svg";
export { ForwardRef as ReactComponent };